import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'

//  TODO: should this exist?
export const getIdAndEmitterTypeFromZoneEmitterTypeKey = (
  irrigationZoneEmitterId: SharedTypes.IrrigationScheduler.TIrrigationZoneEmitterId,
) => {
  const splittedLabel = irrigationZoneEmitterId.split('|||')

  return {
    irrigationZoneId: splittedLabel[0],
    emitterType: splittedLabel[1] as TEmitterType,
  }
}
